<nb-card class="modal-compromisso">
  <nb-card-header class="modal-header">
    <h4>{{ modoEdicao ? 'Editar Compromisso' : 'Novo Compromisso' }}</h4>
    <button class="close-btn" (click)="fechar()" nbButton ghost>
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body class="modal-body">
    <form>
      <div class="form-group">
        <label for="titulo">Título *</label>
        <input 
          type="text" 
          id="titulo"
          nbInput 
          fullWidth 
          placeholder="Digite o título do compromisso" 
          [(ngModel)]="titulo"
          name="titulo"
          [disabled]="carregando">
      </div>

      <div class="form-group">
        <label for="descricao">Descrição *</label>
        <textarea 
          id="descricao"
          nbInput 
          fullWidth 
          rows="4"
          placeholder="Digite a descrição do compromisso" 
          [(ngModel)]="descricao"
          name="descricao"
          [disabled]="carregando">
        </textarea>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="dataCompromisso">Data *</label>
          <input 
            type="date" 
            id="dataCompromisso"
            nbInput 
            fullWidth 
            [(ngModel)]="dataCompromissoFormatada"
            name="dataCompromisso"
            [disabled]="carregando || !modoEdicao">
        </div>

        <div class="form-group col-md-6">
          <label for="horaCompromisso">Horário *</label>
          <input 
            type="time" 
            id="horaCompromisso"
            nbInput 
            fullWidth 
            [(ngModel)]="horaCompromisso"
            name="horaCompromisso"
            [disabled]="carregando">
        </div>
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer class="modal-footer">
    <div class="button-group">
      <button 
        nbButton 
        ghost 
        status="basic" 
        (click)="fechar()"
        [disabled]="carregando">
        Cancelar
      </button>
      <button 
        nbButton 
        status="primary" 
        (click)="salvar()"
        [disabled]="carregando">
        <nb-icon icon="save-outline" *ngIf="!carregando"></nb-icon>
        <nb-icon icon="loader-outline" class="loading-icon" *ngIf="carregando"></nb-icon>
        {{ modoEdicao ? 'Atualizar' : 'Salvar' }}
      </button>
    </div>
  </nb-card-footer>
</nb-card> 